import { getExpressionData } from "api/expression";
import { getTagData } from "api/tags";

const unityGaugeConfig = {
  getTagData,
  getExpressionData
};

export default unityGaugeConfig;